export default function timeZoneOffset() {
  function zeropad(i) {
    if(Math.abs(i) < 10) {
      if(i < 0) {
        return '-0' + i * -1;
      } else {
        return '+0' + i;
      }
    } else {
      if(i < 0) {
        return '' + i;
      } else {
        return '+' + i;
      }

    }
  }
  return zeropad(new Date().getTimezoneOffset() / -60);
}
